import React from 'react'
import SearchPicker from '../common/SearchPicker'

const LocationPicker = (props) => {

    const { state } = props

    const option = (o) => <span>{`${o.code}, ${o.name}`}</span>

    return (
        <SearchPicker
            {...props}
            value={state ? `${state?.code}, ${state?.name}` : ""}
            option={(o) => option(o)}
        />
    )
}

export default LocationPicker